// 关于 omega 报错过滤文档：http://omega.xiaojukeji.com/omegabook/sdk/webLite/

// jsErrorFilters: [
//   { message: /^Script error\.$/ }
// ]
import { getMicroApps, getCommonErrorFilters } from '@/config/apps';

const transformToRegExp = (value) => {
  try {
    return new RegExp(value);
  } catch (err) {
    console.log('正则转换错误：' + value);
    console.error(err);
    return null;
  }
};

const errorFormat = (errorRules = []) => {
  return errorRules
    .map((rule) => transformToRegExp(rule))
    .filter((rule) => !!rule)
    .map((ruleReg) => {
      return {
        message: ruleReg,
      };
    });
};

const initErrorFilters = () => {
  try {
    const commonErrorFilters = getCommonErrorFilters();
    const jsErrorFilters = errorFormat(commonErrorFilters);
    console.log('initErrorFilters', jsErrorFilters);
    window.Omega &&
      window.Omega.setConfig({
        jsErrorFilters,
      });
  } catch (err) {
    console.error(err);
  }
};

const changeErrorFilters = (appName) => {
  try {
    const commonErrorFilters = getCommonErrorFilters();
    const apps = getMicroApps();
    const app = apps.find((app) => app.name === appName) || {};
    const { errorFilters = [] } = app;
    console.log('changeErrorFilters', errorFilters);
    if (errorFilters && errorFilters.length) {
      const appErrorFilters = errorFormat([...commonErrorFilters, ...errorFilters]);
      window.Omega &&
        window.Omega.setConfig({
          jsErrorFilters: appErrorFilters,
        });
    }
  } catch (err) {
    console.error(err);
  }
};

export { initErrorFilters, changeErrorFilters };
